import React from "react";
import Select from "react-select";
import "./style.scss";

export const SelectInput = ({
  containerClassName,
  className,
  placeholder,
  title,
  disabled = false,
  options,
  onChange,
  value,
  isClearable,
  isLoading,
  isSearchable = true,
  required = false,
  menuPlacement = "bottom",
}) => {
  return (
    <div className={`select_container ${containerClassName || ""}`}>
      <p className="title">
        {title}
        {required && <span className="required">*</span>}
      </p>
      <Select
        onChange={(selectedOption) => onChange(selectedOption)}
        value={value.label ? value : null}
        styles={{
          control: (styles) => ({
            ...styles,
            backgroundColor: "#FAFAFA",
            borderRadius: "9px",
            borderColor: "#CECECE",
            boxShadow: "none",
            padding: "8px 16px 8px 5px",
            ":hover": {
              borderColor: "#CECECE",
            },

            "@media (max-width: 768px)": {
              padding: "5px 3px 4px 3px",
            },
          }),
          placeholder: (styles) => ({
            ...styles,
            fontSize: "12px",
            color: "#6D6D70",
          }),
          input: (styles) => ({
            ...styles,
            color: "#000000",
            "::placeholder": {
              color: "red",
            },
          }),
          singleValue: (styles) => ({
            ...styles,
            color: "#000000",
          }),
          option: (styles) => ({
            ...styles,
            backgroundColor: "#FAFAFA",
            marginTop: 1,
            color: "#000000",
            cursor: "pointer",
            textAlign: "right",
            "&:hover": {
              backgroundColor: "#F7F7F7",
            },
          }),
          menu: (styles) => ({
            ...styles,
            backgroundColor: "#FAFAFA",
            padding: "3px 6px",
            fontSize: 14,
            animation: `${
              menuPlacement === "top" ? "MenuFadeInTop" : "MenuFadeInBottom"
            } 0.2s ease-in-out`,
          }),
        }}
        className={`select ${className || ""}`}
        options={options}
        isDisabled={disabled}
        placeholder={placeholder || ""}
        isClearable={isClearable}
        isLoading={isLoading}
        isSearchable={isSearchable}
        noOptionsMessage={() => "موردی یافت نشد"}
        loadingMessage={() => "در حال دریافت..."}
        menuPlacement={menuPlacement}
      />
    </div>
  );
};
